<bit-status-lockup>
  <bit-svg slot="graphic" [content]="noCredentialsIcon"></bit-svg>
  <ng-container slot="title">{{ "nothingToShow" | i18n }}</ng-container>
  <ng-container slot="description">{{ "nothingGeneratedRecently" | i18n }}</ng-container>
</bit-status-lockup>
